import { Listbox } from '@headlessui/react'
import { classNames } from '@progress/kendo-react-common'
import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import React, { SetStateAction } from 'react'
import { DownArrowIcon } from 'utils/custom-icons'
import { getTranslation } from 'utils/language-helper'
export interface IEntrypointOption {
    id: number
    title: string
    subText: string
    value: string
}
export const ENTRY_POINTS: IEntrypointOption[] = [
    {
        id: 1,
        title: 'locations',
        subText: 'locations_subtext',
        value: 'LOCATIONS',
    },
    {
        id: 2,
        title: 'services',
        subText: 'services_subtext',
        value: 'SERVICES',
    },
    {
        id: 3,
        title: 'memberships',
        subText: 'memberships_subtext',
        value: 'MEMBERSHIPS',
    },
    // {
    //     id: 4,
    //     title: 'staff',
    //     subText: 'staff_subtext',
    //     value: 'STAFF',
    // },
]

export const DEFAULT_ENTRY_POINT_KEY = 'ENTRY_POINT'

export interface IEntrypoint<T> {
    selectedEntryPoint: T
    setSelectedEntryPoint: React.Dispatch<SetStateAction<T>>
    setIsDirty?: React.Dispatch<SetStateAction<boolean>>
    label_override?: JSX.Element
}

const EntryPointSelector: React.FC<IEntrypoint<IEntrypointOption>> = ({
    selectedEntryPoint,
    setSelectedEntryPoint,
    setIsDirty = () => false,
    label_override = (
        <span className="mb-4 text-lg">
            <Translation
                render_as="label"
                content_key="default_booking_page_display"
            />
        </span>
    )
}) => {

    return (
        <fieldset>
            {label_override}
            <Listbox
                value={selectedEntryPoint}
                onChange={(val) => {
                    setSelectedEntryPoint(val)
                    setIsDirty(true)
                }}
            >
                <Listbox.Button
                    className={
                        ' mt-2 border-gray-200 rounded-md border-2 px-2 py-1 w-full text-left flex justify-between items-center'
                    }
                >
                    <Translation content_key={selectedEntryPoint.title} />
                    <DownArrowIcon />
                </Listbox.Button>
                <Listbox.Options
                    className={
                        'shadow-lg mt-1 border-gray-200 border-2 rounded-md backdrop-blur-md px-2 py-1'
                    }
                >
                    {ENTRY_POINTS?.map((entryPoint) => (
                        <Listbox.Option
                            className={classNames(
                                'cursor-pointer px-2 py-1 rounded-md text-left',
                                selectedEntryPoint.value ===
                                    entryPoint.value
                                    ? 'bg-primary-lighter'
                                    : 'hover:bg-sky-100'
                            )}
                            key={entryPoint?.id}
                            value={entryPoint}
                        >
                            <div>
                                <h1 className="text-primary text-sm font-semibold ">
                                    <Translation
                                        content_key={entryPoint.title}
                                    />
                                </h1>
                                <p className="text-gray-400">
                                    <Translation
                                        content_key={entryPoint.subText}
                                    />
                                </p>
                            </div>
                        </Listbox.Option>
                    ))}
                </Listbox.Options>
            </Listbox>
        </fieldset>
    )
}

export default EntryPointSelector
